import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "animate.css";

import * as Sentry from "@sentry/react";
import { api_url } from "./api/axios.jsx";

Sentry.init({
  dsn: "https://70eef0385be57c87f11d353a141b7634@o4507311779414016.ingest.de.sentry.io/4507311820636240",
  integrations: [
    // Sentry.browserTracingIntegration(),
    // Sentry.replayIntegration(),
    Sentry.breadcrumbsIntegration({ console: false }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", api_url],
  // Session Replay
  replaysSessionSampleRate: 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
